import { LGraphNode, LiteGraph } from "litegraph.js";

/**
 * MathNode
 * --------
 * Takes two numeric inputs and a selectable operation.
 * Essential glue for combining/transforming values between nodes.
 */
export class MathNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Math";

    this.properties = {
      operation: "add",
      b_value: 0,
    };

    this.addInput("A", "number");
    this.addInput("B", "number");
    this.addOutput("Result", "number");

    this.addWidget("combo", "Op", "add", (val) => {
      this.properties.operation = val;
    }, {
      values: ["add", "subtract", "multiply", "divide", "mod", "pow", "min", "max", "abs", "sin", "cos"]
    });

    this.addWidget("number", "B Default", 0, (val) => {
      this.properties.b_value = val;
    }, { min: -10000, max: 10000, step: 0.1 });

    this.size = [160, 86];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onDrawForeground(ctx) {
    const w = this.size[0];
    const h = this.size[1];
    ctx.fillStyle = "rgba(255,255,255,0.4)";
    ctx.font = "9px monospace";
    ctx.fillText(`= ${(this._lastResult || 0).toFixed(2)}`, 10, h - 6);
  }

  onExecute() {
    const a = this.getInputData(0) || 0;
    const b = this.getInputData(1) != null ? this.getInputData(1) : this.properties.b_value;

    let result = 0;
    switch (this.properties.operation) {
      case "add":      result = a + b; break;
      case "subtract": result = a - b; break;
      case "multiply": result = a * b; break;
      case "divide":   result = b !== 0 ? a / b : 0; break;
      case "mod":      result = b !== 0 ? a % b : 0; break;
      case "pow":      result = Math.pow(a, b); break;
      case "min":      result = Math.min(a, b); break;
      case "max":      result = Math.max(a, b); break;
      case "abs":      result = Math.abs(a); break;
      case "sin":      result = Math.sin(a); break;
      case "cos":      result = Math.cos(a); break;
    }

    this._lastResult = result;
    this.setOutputData(0, result);
  }
}

LiteGraph.registerNodeType("utility/Math", MathNode);
